import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { SpinnerService } from './spinner.service';

@Injectable()
export class DataService {
    constructor(private http: HttpClient, private spinnerService: SpinnerService) {
    }

    public get<T>(url: string, headers?: HttpHeaders | null): Observable<T> {
        // this.spinnerService.show('omsSpinner');
        return this.http.get<T>(url, this.prepareHeader(headers))
            .map(res => {
                // this.spinnerService.hide('omsSpinner');
                return res;
            })
            .catch(error => {
                // this.spinnerService.hide('omsSpinner');
                return Observable.throw(error);
            });
    }

    public post<T>(url: string, body: any, headers?: HttpHeaders | null): Observable<T> {
        // this.spinnerService.show('omsSpinner');
        return this.http.post<T>(url, body, this.prepareHeader(headers))
            .map(res => {
                // this.spinnerService.hide('omsSpinner');
                return res;
            })
            .catch(error => {
                // this.spinnerService.hide('omsSpinner');
                return Observable.throw(error);
            });
    }

    public put<T>(url: string, body: any, headers?: HttpHeaders | null): Observable<T> {
        return this.http.put<T>(url, body, this.prepareHeader(headers))
            .map(res => {
                this.spinnerService.hide('omsSpinner');
                return res;
            })
            .catch(error => {
                this.spinnerService.hide('omsSpinner');
                return Observable.throw(error);
            });
    }

    public delete<T>(url: string, headers?: HttpHeaders | null): Observable<T> {
        return this.http.delete<T>(url, this.prepareHeader(headers))
            .map(res => {
                this.spinnerService.hide('omsSpinner');
                return res;
            })
            .catch(error => {
                this.spinnerService.hide('omsSpinner');
                return Observable.throw(error);
            });
    }

    private prepareHeader(headers: HttpHeaders | null): object {
        headers = headers || new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json');
        headers = headers.set('Accept', 'application/json');
        const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        if (currentUser) {
            const language = (currentUser.locale === 'en') ? 'en' : 'local';
            headers = headers.set('Authorization', currentUser.access_token);
            headers = headers.set('Language', language);
        }
        return {headers: headers};
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/data.service.ts